import DeleteIcon from 'assets/settings/components/DeleteIcon';
import EditIcon from 'assets/settings/components/EditIcon';

import {
  ActionButton,
  ActionsSection,
  Badge,
  BadgesWrapper,
  Card,
  ContentSection,
  CountText,
  CurrentPrice,
  Description,
  DiscountedPrice,
  FeatureItem,
  FeaturesList,
  FeaturesSection,
  FeaturesTitle,
  HeaderSection,
  IconWrapper,
  PriceSection,
  PriceWrapper,
  Title,
  TitleSection,
} from './OfferCard.styles';

const OfferCard = ({
  icon,
  title,
  product,
  status,
  description,
  premiumFeatures,
  discountedPrice,
  currentPrice,
  count,
  onEdit,
  onDelete,
}) => {
  const safeFeatures = premiumFeatures ?? [];
  return (
    <Card>
      <IconWrapper>{icon}</IconWrapper>
      <ContentSection>
        <HeaderSection>
          <TitleSection>
            <Title title={title}>{title}</Title>
            <BadgesWrapper>
              {product && <Badge>{product}</Badge>}
              <Badge
                $type={
                  status?.toLowerCase() === 'enabled' ? 'status-enabled' : 'status-disabled'
                }
              >
                {status}
              </Badge>
            </BadgesWrapper>
          </TitleSection>
          <ActionsSection>
            <ActionButton onClick={onEdit}>
              <EditIcon size={16} color="#2D6CDF" />
            </ActionButton>
            <ActionButton onClick={onDelete} $delete>
              <DeleteIcon size={16} color="#FB2C36" />
            </ActionButton>
          </ActionsSection>
        </HeaderSection>

        {description && <Description title={description}>{description}</Description>}

        {safeFeatures.length > 0 && (
          <FeaturesSection>
            <FeaturesTitle>Premium Features:</FeaturesTitle>
            <FeaturesList>
              {safeFeatures.map((feature, index) => (
                <FeatureItem key={index}>{feature}</FeatureItem>
              ))}
            </FeaturesList>
          </FeaturesSection>
        )}

        <PriceSection>
          <PriceWrapper>
            {discountedPrice && <DiscountedPrice>{discountedPrice} AMD</DiscountedPrice>}
            <CurrentPrice>{currentPrice} AMD</CurrentPrice>
          </PriceWrapper>
          {count != null && <CountText>Count: {count}</CountText>}
        </PriceSection>
      </ContentSection>
    </Card>
  );
};

export default OfferCard;
